globalThis.utils = {
  extend: function (child, parent) { for (var key in parent) { if (utils.hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  include: function (klass, module) { utils.extend(klass.prototype, module.prototype); },
  hasProp: {}.hasOwnProperty,
  capitalize: function(str) { return str.charAt(0).toUpperCase() + str.slice(1); },
  removeUrlHash: function() {
    var scrollV, scrollH, loc = window.location;

    if ('pushState' in history) {
      history.pushState('', document.title, loc.pathname + loc.search);
    } else {
      scrollV = document.body.scrollTop;
      scrollH = document.body.scrollLeft;
      loc.hash = '';
      document.body.scrollTop = scrollV;
      document.body.scrollLeft = scrollH;
    }
  },
  indexOf: function() {
    return [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
  },
  getScript: function(url, options) {
    options = $.extend(options || {}, {
      dataType: 'script',
      cache: true,
      url: url
    });

    return $.ajax(options);
  },
  slugify: function(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/\s+/g, '-')            // Replaces spaces with dashes
      .replace(/[^a-z0-9\-]/g, '')     // Removes non-alphanumeric characters except dashes
      .replace(/-+/g, '-');            // Prevents double dashes
  },
  require: function(assets, callback) {
    window.loadedAssets  = window.loadedAssets || {};

    var _assetsToLoad = [],
        _queuedAssets = [];

    var _arr = $.map(assets, function(asset) {
      if(!window.loadedAssets[asset]) {
        _assetsToLoad.push(asset);

        window.loadedAssets[asset] = 'QUEUED';

        return utils.getScript(asset);
      } else if(window.loadedAssets[asset] == 'QUEUED') {
        _queuedAssets.push(asset);
      }
    });

    var requireAssets = function() {
      if(_arr.length) {
        $.when.apply($, _arr).done(function() {
          $.each(_assetsToLoad, function(index, asset) {
            window.loadedAssets[asset] = 'LOADED';
          });

          callback();
        }).fail(function() {
          console.log(arguments[2].toString());
        });
      } else {
        callback();
      }
    }

    if(_queuedAssets.length) {
      var waitForQueuedAssets = setInterval(function() {
        if(!($.grep(_queuedAssets, function(asset) { return window.loadedAssets[asset] == 'QUEUED' })).length) {
          clearInterval(waitForQueuedAssets);
          requireAssets();
        }
      }, 100);
    } else {
      requireAssets();
    }
  },
  removeAccents: (function () {
    var charMap = {'é':'e','è':'e','ô':'o','ê':'e', 'î':'i'};
    return function (str) {
        var i, result = "", cur;
        for(i = 0; i < str.length; i++) {
            cur = str.charAt(i);
            result += (charMap[cur] || cur);
        }
        return result;
    };
  }()),
  $_GET: (function(param) {
  	var vars = {};
  	window.location.href.replace( location.hash, '' ).replace(
  		/[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
  		function( m, key, value ) { // callback
  			vars[key] = value !== undefined ? value : '';
  		}
  	);

  	if (param) {
  		return vars[param] ? vars[param] : null;
  	}
  	return vars;
  }()),
  lang: {
    fr: {
      indefinitArticleFromNum: function(num, feminine) { return num == 1 ? 'un' + (feminine ? 'e' : '') : num }
    }
  },
  cookies: {
    create: function(name, value, hours, expires_date) {
      var expires = '';
      if(hours) {
        var date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        expires_date = date.toUTCString();
      }
      if(expires_date) {
        expires = '; expires=' + unescape(expires_date);
        if(typeof value == 'object') {
          value.expires_date = escape(expires_date);
        }
      }
      document.cookie = name + '=' + (typeof value == 'object' ? encodeURIComponent(JSON.stringify(value)) : value) + expires + '; path=/';
    },
    get: function(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');

      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return decodeURIComponent(c.substring(nameEQ.length,c.length));
      }

      return null;
    },
    delete: function(name) {
      this.create(name, '', -1);
    }
  },
  removeSelection: function() {
    if(document.selection && document.selection.empty) {
      document.selection.empty();
    } else if(window.getSelection) {
      var sel = window.getSelection();
      sel.removeAllRanges();
    }
  },
  are_colliding: function($div1, $div2) {
    if($div1.length == 0 || $div2.length == 0) { return false; }

    // Div 1 data
    var d1_offset             = $div1.offset();
    var d1_height             = $div1.outerHeight(true);
    var d1_width              = $div1.outerWidth(true);
    var d1_distance_from_top  = d1_offset.top + d1_height;
    var d1_distance_from_left = d1_offset.left + d1_width;

    // Div 2 data
    var d2_offset             = $div2.offset();
    var d2_height             = $div2.outerHeight(true);
    var d2_width              = $div2.outerWidth(true);
    var d2_distance_from_top  = d2_offset.top + d2_height;
    var d2_distance_from_left = d2_offset.left + d2_width;

    var not_colliding = ( d1_distance_from_top < d2_offset.top || d1_offset.top > d2_distance_from_top || d1_distance_from_left < d2_offset.left || d1_offset.left > d2_distance_from_left );
    // Return whether it IS colliding
    return !not_colliding;
  },
  isObject: function(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
  },
  mergeDeep: function(target) {
    var sources = Array.prototype.slice.call(arguments, 1);
    if (!sources.length) return target;
    var source = sources.shift();

    if (utils.isObject(target) && utils.isObject(source)) {
      for (var key in source) {
        if (utils.isObject(source[key])) {
          if (!target[key]) target[key] = {};
          utils.mergeDeep(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }

    return utils.mergeDeep.apply(this, [target].concat(sources));
  },
  delay: function(callback, ms){
    var timer = 0;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  },
  isValidSelector: function(selector) {
    try {
      $(selector);

      return true;
    } catch {
      return false;
    }
  }
};

jQuery.fn.insertAt = function(index, element)
{
    var lastIndex = this.children().size()
    if (index < 0) {
        index = Math.max(0, lastIndex + 1 + index)
    }
    this.append(element)
    if (index < lastIndex) {
        this.children().eq(index).before(this.children().last())
    }
    return this;
};

(function($) {
    $.fn.w = function(parent) {
        var parent = this._parent(parent);
        return (this.width() / parent.width()) * 100;
    }
})(jQuery);

(function($) {
    $.fn.h = function(parent) {
        var parent = this._parent(parent);
        return (this.height() / parent.height()) * 100;
    }
})(jQuery);

(function($) {
    $.fn.p = function(parent) {
        var parent = this._parent(parent);
        return {
            top  : ((this.offset().top - parent.offset().top) / parent.height()) * 100,
            left : ((this.offset().left - parent.offset().left) / parent.width()) * 100
        }
    }
})(jQuery);

(function($) {
    $.fn._parent = function(parent) {
        if(parent) this.data('parent', parent);
        return this.data('parent') || this.parent();
    }
})(jQuery);

(function($) {
    $.fn.elIndex = function(els) {
      var $el = this;

      return els.map(function(index, el) {
        if($el[0] == el) return index;
      })[0];
    }
})(jQuery);
